module.exports = {"513429100":"特木里镇","513429101":"龙潭镇","513429102":"拖觉镇","513429200":"木尔乡","513429201":"九都乡","513429202":"拉达乡","513429203":"乌科乡","513429204":"沙洛乡","513429205":"洛古乡","513429206":"补尔乡","513429207":"觉撒乡","513429208":"美撒乡","513429209":"拉果乡","513429210":"乌依乡","513429211":"浪珠乡","513429212":"包谷坪乡","513429213":"合井乡","513429214":"罗家坪乡","513429215":"牛角湾乡","513429216":"补洛乡","513429217":"火烈乡","513429218":"乐安乡","513429219":"四棵乡","513429220":"地洛乡","513429221":"俄里坪乡","513429222":"瓦都乡","513429223":"采哈乡","513429224":"委只洛乡","513429225":"联补乡","513429226":"基只乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513429.json
// module id = 2252
// module chunks = 0